import React, { useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import {Download} from "react-bootstrap-icons";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import "./trainingTable.css"; // Import the CSS file
import formatDate from "../../utils/helpers/formatDate";
import * as XLSX from "xlsx";


export interface Training {
  id: number;
  name: string;
  created: Date;
  all_employee: number;
  emp_code: string;
  designation: string;
  email: string;
  mobileNo: string;
  status: number;
  modified: Date;
  external_link?: string;
  isExternalLinkEnabled: boolean;
  attempted: number;
  assigned: number;
}

const TrainingTable = () => {
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const [training, setTraining] = useState<Training[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (cmpMounted.current) return;
    cmpMounted.current = true;
    fetchPeople();
  }, []);

  const fetchPeople = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.GET_TRAINING_DATA, {});
      console.log(response);

      const sortedItems = response.data.reduce(
        (acc: Training[], item: Training) => {
          const formattedItemDate = new Date(item.modified).toISOString();
          const index = acc.findIndex(
            (i) => new Date(i.modified).toISOString() < formattedItemDate
          );

          if (index === -1) {
            acc.push(item);
          } else {
            acc.splice(index, 0, item);
          }
          return acc;
        },
        []
      );

      setTraining(sortedItems);
    } catch (error) {
      console.error("Failed to fetch training data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const toggleStatus = async (item: Training) => {
    try {
      const newStatus = item.status === 0 ? 1 : 0;
      const response = await postDetails(APIList.TRAINING_STATUS, {
        id: item.id,
        status: newStatus,
      });

      if (response.status === "Failed") {
        console.log("Cannot update status");
        return;
      }

      setTraining((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, status: newStatus } : row
        )
      );
      console.log("Status updated");
      dispatch(showToast("Status Successfully Changed"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const editItem = (item: Training) => {
    navigate(`/training/edit/${item.id}`);
  };
 
  

  const deleteItemById = async (item: Training) => {
    try {
      const response = await postDetails(APIList.DELETE_TRAINING_DATA, {
        id: item.id,
      });
      if (response.status === "Failed") {
        alert("Cannot delete user");
        return;
      }
      setTraining((prevData) =>
        prevData.filter((row: Training) => row.id !== item.id)
      );
      dispatch(showToast("Successfully Deleted"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Failed to delete training:", error);
    }
  };

  const handleViewContent = (item: Training) => {
    if (item.external_link) {
      window.open(item.external_link, "_blank");
    } else {
      navigate(`/training/view/${item.id}`);
    }
  };

  const handleView = (item: Training) => {
    if (item.external_link) {
      console.log("Does not have any Content");
    } else {
      navigate(`/training/view/${item.id}`);
    }
  };

  const modifiedTrainingData = training.map((item) => ({
    ...item,
    viewContentButton: item.external_link ? null : (
      <button className="button" onClick={() => handleViewContent(item)}>
        View Content
      </button>
    ),
  }));

  const handleDownloadReport = async (item: any)=>{
      try {
        dispatch(showLoader("Downloading data..."));
        const payload = {
          id: item.id
        };
        const response = await postDetails(APIList.GET_TRAINING_REPORTS, payload);
  
        // if(response.data.length > 0){
        // const modifiedData = response.data.map((item: any) => ({
        //   ...item,
        //   submittedDate: new Date(item.submittedDate).toLocaleString(
        //     "en-GB",
        //     {
        //       day: "2-digit",
        //       month: "2-digit",
        //       year: "numeric",
        //       hour: "2-digit",
        //       minute: "2-digit",
        //       hour12: true,
        //     }
        //   ),
        // }));

        const modifiedData = response.data.map((item: any) => ({
          Training: item.training,
          "Submitted User": item.submitedUser,
          "Submitted Date": new Date(item.submittedDate).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          "Employee Code": item.EmployeeCode,
          Email: item.Email,
          Designation: item.designation,
        }));

        const headers = [
          "Training",
          "Submitted User",
          "Submitted Date",
          "Employee Code",
          "Email",
          "Designation",
        ];

        const ws = XLSX.utils.json_to_sheet([], { header: headers });
        XLSX.utils.sheet_add_json(ws, modifiedData, {
          skipHeader: true,
          origin: "A2", 
        });
  
        // const ws = XLSX.utils.json_to_sheet(modifiedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Training_Report");
  
        XLSX.writeFile(wb, `Training_Report.xlsx`);
      // } else {
      //   dispatch(showToast("No Data Available."));
      //   setTimeout(() => dispatch(hideToast()), 3000);
      // }
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(showToast("Some error occurred while fetching data"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        dispatch(hideLoader());
      }
  }

  const columns: TableColumn[] = [
    // { key: "id", label: "ID", sortable: true },
    { key: "name", label: "Training Name", sortable: true, dataType: "string" },
    {
      key: "all_employee",
      label: "For Group/Employee",
      render: (item: Training) => {
        switch (item.all_employee) {
          case 0:
            return "Employee";
          case 1:
            return "All Employees";
          case 2:
            return "Groups";
          default:
            return "Unknown";
        }
      },
    },
    {
      key: "created",
      label: "Created On",
      sortable: true,
      render: (record) =>
        new Date(record.created).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
    },
    {
      key: "viewContentButton",
      label: "View Content",
      dataType: "button",
      render: (item: Training) => {
        if (item.external_link) {
          return null;
        }
        return (
          <button className="button" onClick={() => handleView(item)}>
            View Content
          </button>
        );
      },
    },
    { key: "attempted", label: "Attempted", sortable: false, dataType: "string" },
    { key: "assigned", label: "Assigned", sortable: false, dataType: "string" },
    {
      key: "",
      label: "Download Report",
      dataType: "button",
      render: (item: Training) => {
        if (item.attempted === 0) {
          return "N/A";
        }
        return (
          <button className="button btn-sm" onClick={() => handleDownloadReport(item)}>
            <Download />
          </button>
        );
      },
    },
    // ,
    // { key: "attempted", label: "Completion Count", sortable: true, dataType: "string" },
  ];

  return (
    <div>
      <CommonTable<Training>
        data={modifiedTrainingData}
        columns={columns}
        onEdit={editItem}
        onDelete={deleteItemById}
        onStatusToggle={toggleStatus}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: true,
          status: true,
          showModal: false,
        }}
      />
    </div>
  );
};

export default TrainingTable;
